import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { CURRENCY } from "../../../constants/DeliveryConstants";

const Index = React.memo(({ record, localCustomPrices, onPriceChange, disabled }) => {
  const customPrice = localCustomPrices[record.id];
  const displayPrice = customPrice || record.price;
  const standardPrice = parseFloat(record.price).toFixed(2);
  const currentPrice = customPrice ? parseFloat(customPrice).toFixed(2) : standardPrice;
  const isChanged = currentPrice !== standardPrice;

  const [localValue, setLocalValue] = useState(displayPrice);

  // Update local value when displayPrice changes (e.g., from reset or external update)
  useEffect(() => {
    setLocalValue(displayPrice);
  }, [displayPrice]);

  const handleBlur = () => {
    onPriceChange(record.id, localValue);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onPriceChange(record.id, localValue);
    }
  };

  return (
    <Input
      type="number"
      step="0.01"
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={handleBlur}
      onKeyPress={handleKeyPress}
      prefix={CURRENCY}
      disabled={disabled}
      style={{
        backgroundColor: isChanged ? "rgba(136, 14, 79, 0.1)" : "transparent",
        fontWeight: isChanged ? 600 : "normal",
        color: isChanged ? "#880e4f" : "inherit",
      }}
    />
  );
});

Index.displayName = "EditablePriceInput";

export default Index;
